import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

interface CurrencyItem {
    code: string;
    symbol: string;
    flag: string;
}

interface LanguageItem {
    code: string;
    name: string;
    flag: string;
}

@Component({
    selector: 'app-public-header-layout',
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        RouterLinkActive
    ],
    templateUrl: './public-header-layout.component.html',
    styleUrl: './public-header-layout.component.scss'
})
export class PublicHeaderLayoutComponent {

    currencyDropdownOpen = false;
    languageDropdownOpen = false;

    readonly currencies: CurrencyItem[] = [
        {
            code: 'USD',
            symbol: '$',
            flag: '🇺🇸'
        },
        {
            code: 'EUR',
            symbol: '€',
            flag: '🇪🇺'
        },
        {
            code: 'GBP',
            symbol: '£',
            flag: '🇬🇧'
        },
        {
            code: 'TRY',
            symbol: '₺',
            flag: '🇹🇷'
        }
    ];

    readonly languages: LanguageItem[] = [
        {
            code: 'TR',
            name: 'Türkçe',
            flag: '🇹🇷'
        },
        {
            code: 'EN',
            name: 'English',
            flag: '🇬🇧'
        }
    ];

    selectedCurrency: CurrencyItem = this.currencies[0];
    selectedLanguage: LanguageItem = this.languages[0];

    constructor(private readonly router: Router) {
    }

    ToggleCurrencyDropdown(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();

        this.currencyDropdownOpen = !this.currencyDropdownOpen;
        this.languageDropdownOpen = false;
    }

    ToggleLanguageDropdown(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();

        this.languageDropdownOpen = !this.languageDropdownOpen;
        this.currencyDropdownOpen = false;
    }

    SelectCurrency(currency: CurrencyItem, event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();

        this.selectedCurrency = currency;
        this.currencyDropdownOpen = false;
    }

    SelectLanguage(language: LanguageItem, event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();

        this.selectedLanguage = language;
        this.languageDropdownOpen = false;

        console.log('Dil değiştirildi:', language.code);

        /*
        Burada gerçek dil değiştirme servisini çağıracağız.

        Örnek:

        this.languageService.ChangeLanguage(language.code);
        */
    }

    Login(): void {
        this.router.navigate(['/login']);
    }

    @HostListener('document:click')
    CloseDropdowns(): void {
        this.currencyDropdownOpen = false;
        this.languageDropdownOpen = false;
    }

}